import {
    axiosGet,
    axiosGetJournal,
    axiosPost,
    axiosPut,
} from "../../utilities/axiosRequest"
import { logTransaction } from "../appActions"
import {
    aptReportURL,
    carePerformanceReportURL,
    consentReportURL,
    revenueReportURL,
    bhnReportURL,
    mstReportURL,
    carePlanReportURL,
    getDocumentsURL,
    performanceReportGraphURL,
    getPerformanceReportBeakDown,
    getPatientLevelPerformanceReport,
    downloadAllReportURL,
    patientDemographic,
    patientAssessmentNamesScores,
    patientSummaryNotes,
    patientCarePercent,
    patientAssessmentResponses,
    patientAppointment,
    patientCareGoals,
    patientFooter,
    getOrganizationTemplate,
    saveOrgTemplate,
    bhnTimeReportURL,
    billablePatientStatusCountURL,
    appointmentsReportURL,
    consultantPatientCareCountUrl,
    consultantProductivityUrl,
    clientsReportURL,
    clientsProgressURL,
    lastCareGivenClientListURL,
    revenueSplitReportURL,
    getCMS1500FormDetailsUrl,
} from "../../apiEndPoints"
import {
    updateAptReport,
    updateConsentReport,
    updatedSelectedPatient,
} from "./reportSlice"
import axios from "axios"
import { schedulerInstance } from "../../utilities/axios"
import moment from "moment"

//consent report

export function fetchAppointmentsReport(data, success, failure) {
    return async function (dispatch, getState) {
        let url = appointmentsReportURL + `?clinicId=${data.clinicId}`
        // if (data?.startDate && data?.endDate) {
        //     url += `&startDate=${moment(data.startDate).format(
        //         "YYYY-MM-DD HH:MM:SS"
        //     )}&endDate=${moment(data.endDate).format("YYYY-MM-DD HH:MM:SS")}`
        // }
        if (data?.forDate) url += `&forDate=${data.forDate}`
        if (data?.month) url += `&month=${data.month}`
        if (data?.year) url += `&year=${data.year}`
        if (data?.type) url += `&type=${data.type}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch data")
                }
            })
            .catch(err => {
                failure(err)
            })
        // if (data?.type === "All") {
        //     if (data?.startDate && data?.endDate) {
        //         url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&type=${data?.type}`
        //     } else if (data?.date) {
        //         url += `&startDate=${data?.date}&type=${data?.type}`
        //     } else {
        //         url += `&month=${data?.month?.id}&year=${data?.year?.id}&type=${data?.type}`
        //     }
        // } else {
        //     if (data?.orgId) {
        //         if (data?.startDate && data?.endDate) {
        //             url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&orgId=${data?.orgId}`
        //         } else if (data?.date) {
        //             url += `&startDate=${data?.date}&orgId=${data?.orgId}`
        //         } else {
        //             url += `&month=${data?.month?.id}&year=${data?.year?.id}&orgId=${data?.orgId}`
        //         }
        //     } else if (data?.clinicId) {
        //         if (data?.startDate && data?.endDate) {
        //             url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&clinicId=${data?.clinicId}`
        //         } else if (data?.date) {
        //             url += `&startDate=${data?.date}&clinicId=${data?.clinicId}`
        //         } else {
        //             url += `&month=${data?.month?.id}&year=${data?.year?.id}&clinicId=${data?.clinicId}`
        //         }
        //     }
        // }
        // console.log("fetchConsentReport", url)
        // if (data.isDownload) {
        //     // downloadAllReport(url+`&isDownload=${data.isDownload}`)
        //     url += `&isDownload=${data.isDownload}`

        //     try {
        //         const response = await axiosGet(url, {}, {}, {}, "blob")

        //         // Log the entire response to check if it is coming properly
        //         console.log("Response received:", response)

        //         if (response.status === 200) {
        //             const blob = new Blob([response.data], {
        //                 type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        //             })

        //             // Create a FileReader to read the blob data for logging purposes
        //             const reader = new FileReader()
        //             reader.onloadend = () => {
        //                 console.log("File content as text:", reader.result)
        //             }
        //             reader.readAsText(blob)

        //             // Proceed with file download
        //             const link = document.createElement("a")
        //             link.href = window.URL.createObjectURL(blob)
        //             link.download = "ConsentDaily.xlsx"
        //             document.body.appendChild(link) // Append the link to the body
        //             link.click()
        //             document.body.removeChild(link) // Remove the link after clicking
        //             console.log("File downloaded successfully")
        //             onSuccess()
        //         } else {
        //             onFailure()
        //             console.error(
        //                 "Failed to download file: ",
        //                 response.statusText
        //             )
        //         }
        //     } catch (err) {
        //         onFailure()
        //         console.error("Error downloading the report", err)
        //     }
        // } else if (data?.sendToemail) {
        //     url += `&sendToemail=${data.sendToemail}`
        //     console.log("urlllllllllllllll", url)
        //     axiosGet(url).then(response => {
        //         if (
        //             response.data.responseData !== null &&
        //             response.data.responseData.length > 0
        //         ) {
        //             onSuccess("Email sent successfully")
        //         } else {
        //             onFailure("Email sent failed")
        //         }
        //     })
        // } else {
        //     axiosGet(url)
        //         .then(response => {
        //             if (
        //                 response.data.responseData !== null &&
        //                 response.data.responseData.length > 0
        //             ) {
        //                 onSuccess(response.data.responseData)
        //                 dispatch(
        //                     updateConsentReport(response.data.responseData)
        //                 )
        //                 dispatch(
        //                     logTransaction("Fetch Consent Report", response)
        //                 )
        //             } else {
        //                 onFailure(response.data.responseData)
        //                 dispatch(updateConsentReport([]))
        //                 dispatch(
        //                     logTransaction(
        //                         "Fetch Consent Report Failed",
        //                         response
        //                     )
        //                 )
        //             }
        //         })
        //         .catch(err => {
        //             dispatch(updateConsentReport([]))
        //             dispatch(logTransaction("Fetch Consent Report Failed", err))
        //         })
        // }
    }
}

export function fetchConsultantPatientCareCount(data, success, failure) {
    return async function (dispatch, getState) {
        let url = consultantPatientCareCountUrl + `?clinicId=${data.clinicId}`
        if (data?.startDate && data?.endDate) {
            url += `&startDate=${moment(data.startDate).format(
                "YYYY-MM-DD HH:MM:SS"
            )}&endDate=${moment(data.endDate).format("YYYY-MM-DD HH:MM:SS")}`
        }
        if (data?.month) url += `&month=${data.month}`
        if (data?.year) url += `&year=${data.year}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch data")
                }
            })
            .catch(err => {
                failure(err)
            })
    }
}

export function fetchClientsReport(data, success, failure) {
    return async function (dispatch, getState) {
        let url = clientsReportURL + `?clinicId=${data.clinicId}`
        // if (data?.startDate && data?.endDate) {
        //     url += `&startDate=${moment(data.startDate).format(
        //         "YYYY-MM-DD HH:MM:SS"
        //     )}&endDate=${moment(data.endDate).format("YYYY-MM-DD HH:MM:SS")}`
        // }
        if (data?.forDate) url += `&forDate=${data.forDate}`
        if (data?.month) url += `&month=${data.month}`
        if (data?.year) url += `&year=${data.year}`
        if (data?.type) url += `&type=${data.type}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch data")
                }
            })
            .catch(err => {
                failure(err)
            })
    }
}

export function fetchLastCareGivenClientListReport(data, success, failure) {
    return async function (dispatch, getState) {
        let url =
            lastCareGivenClientListURL +
            `?clinicId=${data.clinicId}&type=${data.type}`
        // if (data?.startDate && data?.endDate) {
        //     url += `&startDate=${moment(data.startDate).format(
        //         "YYYY-MM-DD HH:MM:SS"
        //     )}&endDate=${moment(data.endDate).format("YYYY-MM-DD HH:MM:SS")}`
        // }
        // if (data?.forDate) url += `&forDate=${data.forDate}`
        // if (data?.month) url += `&month=${data.month}`
        // if (data?.year) url += `&year=${data.year}`
        // if (data?.type) url += `&type=${data.type}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch data")
                }
            })
            .catch(err => {
                failure(err)
            })
    }
}

export function fetchClientsProgress(data, success, failure) {
    return async function (dispatch, getState) {
        let url = clientsProgressURL + `?clinicId=${data.clinicId}`
        // if (data?.startDate && data?.endDate) {
        //     url += `&startDate=${moment(data.startDate).format(
        //         "YYYY-MM-DD HH:MM:SS"
        //     )}&endDate=${moment(data.endDate).format("YYYY-MM-DD HH:MM:SS")}`
        // }
        if (data?.forDate) url += `&forDate=${data.forDate}`
        if (data?.month) url += `&month=${data.month}`
        if (data?.year) url += `&year=${data.year}`
        if (data?.type) url += `&type=${data.type}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch data")
                }
            })
            .catch(err => {
                failure(err)
            })
    }
}

export function fetchClinicProductivity(data, success, failure) {
    return async function (dispatch, getState) {
        let url = consultantProductivityUrl + `?clinicId=${data.clinicId}`
        // if (data?.startDate && data?.endDate) {
        //     url += `&startDate=${moment(data.startDate).format(
        //         "YYYY-MM-DD HH:MM:SS"
        //     )}&endDate=${moment(data.endDate).format("YYYY-MM-DD HH:MM:SS")}`
        // }
        if (data?.forDate) url += `&forDate=${data.forDate}`
        if (data?.month) url += `&month=${data.month}`
        if (data?.year) url += `&year=${data.year}`
        if (data?.type) url += `&type=${data.type}`
        axiosGet(url)
            .then(response => {
                if (
                    response?.data?.responseData !== null &&
                    response.data.responseData?.length > 0
                ) {
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch data")
                }
            })
            .catch(err => {
                failure(err)
            })
        // if (data?.type === "All") {
        //     if (data?.startDate && data?.endDate) {
        //         url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&type=${data?.type}`
        //     } else if (data?.date) {
        //         url += `&startDate=${data?.date}&type=${data?.type}`
        //     } else {
        //         url += `&month=${data?.month?.id}&year=${data?.year?.id}&type=${data?.type}`
        //     }
        // } else {
        //     if (data?.orgId) {
        //         if (data?.startDate && data?.endDate) {
        //             url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&orgId=${data?.orgId}`
        //         } else if (data?.date) {
        //             url += `&startDate=${data?.date}&orgId=${data?.orgId}`
        //         } else {
        //             url += `&month=${data?.month?.id}&year=${data?.year?.id}&orgId=${data?.orgId}`
        //         }
        //     } else if (data?.clinicId) {
        //         if (data?.startDate && data?.endDate) {
        //             url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&clinicId=${data?.clinicId}`
        //         } else if (data?.date) {
        //             url += `&startDate=${data?.date}&clinicId=${data?.clinicId}`
        //         } else {
        //             url += `&month=${data?.month?.id}&year=${data?.year?.id}&clinicId=${data?.clinicId}`
        //         }
        //     }
        // }
        // console.log("fetchConsentReport", url)
        // if (data.isDownload) {
        //     // downloadAllReport(url+`&isDownload=${data.isDownload}`)
        //     url += `&isDownload=${data.isDownload}`

        //     try {
        //         const response = await axiosGet(url, {}, {}, {}, "blob")

        //         // Log the entire response to check if it is coming properly
        //         console.log("Response received:", response)

        //         if (response.status === 200) {
        //             const blob = new Blob([response.data], {
        //                 type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        //             })

        //             // Create a FileReader to read the blob data for logging purposes
        //             const reader = new FileReader()
        //             reader.onloadend = () => {
        //                 console.log("File content as text:", reader.result)
        //             }
        //             reader.readAsText(blob)

        //             // Proceed with file download
        //             const link = document.createElement("a")
        //             link.href = window.URL.createObjectURL(blob)
        //             link.download = "ConsentDaily.xlsx"
        //             document.body.appendChild(link) // Append the link to the body
        //             link.click()
        //             document.body.removeChild(link) // Remove the link after clicking
        //             console.log("File downloaded successfully")
        //             onSuccess()
        //         } else {
        //             onFailure()
        //             console.error(
        //                 "Failed to download file: ",
        //                 response.statusText
        //             )
        //         }
        //     } catch (err) {
        //         onFailure()
        //         console.error("Error downloading the report", err)
        //     }
        // } else if (data?.sendToemail) {
        //     url += `&sendToemail=${data.sendToemail}`
        //     console.log("urlllllllllllllll", url)
        //     axiosGet(url).then(response => {
        //         if (
        //             response.data.responseData !== null &&
        //             response.data.responseData.length > 0
        //         ) {
        //             onSuccess("Email sent successfully")
        //         } else {
        //             onFailure("Email sent failed")
        //         }
        //     })
        // } else {
        //     axiosGet(url)
        //         .then(response => {
        //             if (
        //                 response.data.responseData !== null &&
        //                 response.data.responseData.length > 0
        //             ) {
        //                 onSuccess(response.data.responseData)
        //                 dispatch(
        //                     updateConsentReport(response.data.responseData)
        //                 )
        //                 dispatch(
        //                     logTransaction("Fetch Consent Report", response)
        //                 )
        //             } else {
        //                 onFailure(response.data.responseData)
        //                 dispatch(updateConsentReport([]))
        //                 dispatch(
        //                     logTransaction(
        //                         "Fetch Consent Report Failed",
        //                         response
        //                     )
        //                 )
        //             }
        //         })
        //         .catch(err => {
        //             dispatch(updateConsentReport([]))
        //             dispatch(logTransaction("Fetch Consent Report Failed", err))
        //         })
        // }
    }
}

export function fetchConsentReport(data, onSuccess, onFailure) {
    return async function (dispatch, getState) {
        let program = getState().user?.program
        let url = consentReportURL + `?programId=${program.id}`
        if (data?.type === "All") {
            if (data?.startDate && data?.endDate) {
                url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&type=${data?.type}`
            } else if (data?.date) {
                url += `&startDate=${data?.date}&type=${data?.type}`
            } else {
                url += `&month=${data?.month?.id}&year=${data?.year?.id}&type=${data?.type}`
            }
        } else {
            if (data?.orgId) {
                if (data?.startDate && data?.endDate) {
                    url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&orgId=${data?.orgId}`
                } else if (data?.date) {
                    url += `&startDate=${data?.date}&orgId=${data?.orgId}`
                } else {
                    url += `&month=${data?.month?.id}&year=${data?.year?.id}&orgId=${data?.orgId}`
                }
            } else if (data?.clinicId) {
                if (data?.startDate && data?.endDate) {
                    url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&clinicId=${data?.clinicId}`
                } else if (data?.date) {
                    url += `&startDate=${data?.date}&clinicId=${data?.clinicId}`
                } else {
                    url += `&month=${data?.month?.id}&year=${data?.year?.id}&clinicId=${data?.clinicId}`
                }
            }
        }
        console.log("fetchConsentReport", url)
        if (data.isDownload) {
            // downloadAllReport(url+`&isDownload=${data.isDownload}`)
            url += `&isDownload=${data.isDownload}`

            try {
                const response = await axiosGet(url, {}, {}, {}, "blob")

                // Log the entire response to check if it is coming properly
                console.log("Response received:", response)

                if (response.status === 200) {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })

                    // Create a FileReader to read the blob data for logging purposes
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        console.log("File content as text:", reader.result)
                    }
                    reader.readAsText(blob)

                    // Proceed with file download
                    const link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "ConsentDaily.xlsx"
                    document.body.appendChild(link) // Append the link to the body
                    link.click()
                    document.body.removeChild(link) // Remove the link after clicking
                    console.log("File downloaded successfully")
                    onSuccess()
                } else {
                    onFailure()
                    console.error(
                        "Failed to download file: ",
                        response.statusText
                    )
                }
            } catch (err) {
                onFailure()
                console.error("Error downloading the report", err)
            }
        } else if (data?.sendToemail) {
            url += `&sendToemail=${data.sendToemail}`
            console.log("urlllllllllllllll", url)
            axiosGet(url).then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess("Email sent successfully")
                } else {
                    onFailure("Email sent failed")
                }
            })
        } else {
            axiosGet(url)
                .then(response => {
                    if (
                        response.data.responseData !== null &&
                        response.data.responseData.length > 0
                    ) {
                        onSuccess(response.data.responseData)
                        dispatch(
                            updateConsentReport(response.data.responseData)
                        )
                        dispatch(
                            logTransaction("Fetch Consent Report", response)
                        )
                    } else {
                        onFailure(response.data.responseData)
                        dispatch(updateConsentReport([]))
                        dispatch(
                            logTransaction(
                                "Fetch Consent Report Failed",
                                response
                            )
                        )
                    }
                })
                .catch(err => {
                    dispatch(updateConsentReport([]))
                    dispatch(logTransaction("Fetch Consent Report Failed", err))
                })
        }
    }
}

export function fetchConsentDownloadReport(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = consentReportURL + `?programId=${program.id}`
        if (data?.orgId) {
            if (data?.startDate && data?.endDate) {
                url += `?startDate=${data?.startDate}&endDate=${data?.endDate}&orgId=${data?.orgId}`
            } else if (data?.date) {
                url += `?startDate=${data?.date}&orgId=${data?.orgId}`
            } else {
                url += `?month=${data?.month?.id}&year=${data?.year?.id}&orgId=${data?.orgId}`
            }
        } else if (data?.clinicId) {
            if (data?.startDate && data?.endDate) {
                url += `?startDate=${data?.startDate}&endDate=${data?.endDate}&clinicId=${data?.clinicId}`
            } else if (data?.date) {
                url += `?startDate=${data?.date}&clinicId=${data?.clinicId}`
            } else {
                url += `?month=${data?.month?.id}&year=${data?.year?.id}&clinicId=${data?.clinicId}`
            }
        }

        axiosGet(url)
            .then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess(response.data.responseData)

                    dispatch(logTransaction("Fetch Consent Report", response))
                } else {
                    onFailure(response.data.responseData)

                    dispatch(
                        logTransaction("Fetch Consent Report Failed", response)
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Consent Report Failed", err))
            })
    }
}

//appointment report

export function fetchAptReport(data, onSuccess, onFailure) {
    return async function (dispatch, getState) {
        let program = getState().user?.program
        let url = aptReportURL + `?programId=${program.id}`
        if (data?.type === "All") {
            url += `?month=${data?.month}&year=${data?.year}&type=${data?.type}`
        } else {
            if (data?.orgId) {
                url += data?.date
                    ? `?startDate=${data?.date}&orgId=${data?.orgId}`
                    : `?month=${data?.month}&year=${data?.year}&orgId=${data?.orgId}`
            } else if (data?.clinicId) {
                url += data?.date
                    ? `?startDate=${data?.date}&clinicId=${data?.clinicId}`
                    : `?month=${data?.month}&year=${data?.year}&clinicId=${data?.clinicId}`
            } else {
                url += data?.date
                    ? `?startDate=${data?.date}`
                    : `?month=${data?.month}&year=${data?.year}`
            }
        }

        if (data.isDownload) {
            // downloadAllReport(url+`&isDownload=${data.isDownload}`)
            url += `&isDownload=${data.isDownload}`

            try {
                const response = await axiosGet(url, {}, {}, {}, "blob")

                // Log the entire response to check if it is coming properly
                console.log("Response received:", response)

                if (response.status === 200) {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })

                    // Create a FileReader to read the blob data for logging purposes
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        console.log("File content as text:", reader.result)
                    }
                    reader.readAsText(blob)

                    // Proceed with file download
                    const link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "ApointmentReport.xlsx"
                    document.body.appendChild(link) // Append the link to the body
                    link.click()
                    document.body.removeChild(link) // Remove the link after clicking
                    console.log("File downloaded successfully")
                    onSuccess()
                } else {
                    onFailure()
                    console.error(
                        "Failed to download file: ",
                        response.statusText
                    )
                }
            } catch (err) {
                onFailure()
                console.error("Error downloading the report", err)
            }
        } else if (data?.sendToemail) {
            url += `&sendToemail=${data.sendToemail}`
            console.log("urlllllllllllllll", url)
            axiosGet(url).then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess("Email sent successfully")
                } else {
                    onFailure("Email sent failed")
                }
            })
        } else {
            axiosGet(url)
                .then(response => {
                    if (
                        response.data.responseData !== null &&
                        response.data.responseData.length > 0
                    ) {
                        onSuccess(response.data.responseData)
                        dispatch(updateAptReport(response.data.responseData))
                        dispatch(
                            logTransaction("Fetch Appointment Report", response)
                        )
                    } else {
                        onFailure(response.data.responseData)
                        dispatch(updateAptReport([]))
                        dispatch(
                            logTransaction(
                                "Fetch Appointment Report Failed",
                                response
                            )
                        )
                    }
                })
                .catch(err => {
                    dispatch(updateAptReport([]))
                    dispatch(
                        logTransaction("Fetch Appointment Report Failed", err)
                    )
                })
        }
    }
}

export function fetchAptDownloadReport(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = aptReportURL + `?programId=${program.id}`
        if (data?.orgId) {
            url += data?.date
                ? `?startDate=${data?.date}&orgId=${data?.orgId}`
                : `?month=${data?.month}&year=${data?.year}&orgId=${data?.orgId}`
        } else if (data?.clinicId) {
            url += data?.date
                ? `?startDate=${data?.date}&clinicId=${data?.clinicId}`
                : `?month=${data?.month}&year=${data?.year}&clinicId=${data?.clinicId}`
        } else {
            url += data?.date
                ? `?startDate=${data?.date}`
                : `?month=${data?.month}&year=${data?.year}`
        }

        axiosGet(url)
            .then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess(response.data.responseData)

                    dispatch(
                        logTransaction("Fetch Appointment Report", response)
                    )
                } else {
                    onFailure(response.data.responseData)

                    dispatch(
                        logTransaction(
                            "Fetch Appointment Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Appointment Report Failed", err))
            })
    }
}

//revenue apis

export function fetchRevenueReport(data, onSuccess, onFailure) {
    return async function (dispatch, getState) {
        let program = getState().user?.program
        let url = revenueReportURL + `?programId=${program.id}`
        if (data?.type === "All") {
            if (data?.isSixMonths) {
                url += `&isSixMonths=${data.isSixMonths}&type=${data?.type}`
            } else if (data?.year && data?.month) {
                url += `&month=${data?.month}&year=${data?.year}&type=${data?.type}`
            } else {
                url += `&year=${data?.year}&type=${data?.type}`
            }
        } else {
            if (data?.isSixMonths) {
                url += `&orgId=${data.orgId}&isSixMonths=${data.isSixMonths}`
            } else if (data?.orgId) {
                if (data?.year && data?.month) {
                    url += `&month=${data?.month}&year=${data.year}&orgId=${data.orgId}`
                } else {
                    url += `&year=${data.year}&orgId=${data.orgId}`
                }
            } else if (data?.clinicId) {
                if (data?.year && data?.month) {
                    url += `&month=${data.month}&year=${data.year}`
                } else {
                    url += `&year=${data.year}`
                }
            } else {
                url += `&month=${data.month}&year=${data.year}`
            }
        }
        if (data.isDownload) {
            // downloadAllReport(url+`&isDownload=${data.isDownload}`)
            url += `&isDownload=${data.isDownload}`

            try {
                const response = await axiosGet(url, {}, {}, {}, "blob")

                // Log the entire response to check if it is coming properly
                console.log("Response received:", response)

                if (response.status === 200) {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })

                    // Create a FileReader to read the blob data for logging purposes
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        console.log("File content as text:", reader.result)
                    }
                    reader.readAsText(blob)

                    // Proceed with file download
                    const link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "Revenue.xlsx"
                    document.body.appendChild(link) // Append the link to the body
                    link.click()
                    document.body.removeChild(link) // Remove the link after clicking
                    console.log("File downloaded successfully")
                    onSuccess()
                } else {
                    onFailure()
                    console.error(
                        "Failed to download file: ",
                        response.statusText
                    )
                }
            } catch (err) {
                onFailure()
                console.error("Error downloading the report", err)
            }
        } else if (data?.sendToemail) {
            url += `&sendToemail=${data.sendToemail}`
            console.log("urlllllllllllllll", url)
            axiosGet(url).then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess("Email sent successfully")
                } else {
                    onFailure("Email sent failed")
                }
            })
        } else {
            axiosGet(url)
                .then(response => {
                    if (
                        response.data.responseData !== null &&
                        response.data.responseData.length > 0
                    ) {
                        onSuccess(response.data.responseData)
                        dispatch(
                            logTransaction("Fetch Revenue Report", response)
                        )
                    } else {
                        onFailure(response.data.responseData)
                        dispatch(
                            logTransaction(
                                "Fetch Revenue Report Failed",
                                response
                            )
                        )
                    }
                })
                .catch(err => {
                    dispatch(logTransaction("Fetch Revenue Report Failed", err))
                })
        }
    }
}

export function fetchMonthlyRevenueReport(data, onSuccess, onFailure) {
    return async function (dispatch, getState) {
        let program = getState().user?.program
        let url = revenueSplitReportURL
        axiosGet(url, {}, { ...data, programId: program.id })
            .then(response => {
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                    dispatch(logTransaction("Fetch Revenue Report", response))
                } else {
                    onFailure(response.data.responseData)
                    dispatch(
                        logTransaction("Fetch Revenue Report Failed", response)
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Revenue Report Failed", err))
            })
    }
}

//care performance apis

export function fetchCarePerformanceReport(data, onSuccess, onFailure) {
    return async function (dispatch, getState) {
        let program = getState().user?.program
        let url = carePerformanceReportURL + `?programId=${program.id}`
        if (data?.type === "All") {
            if (data?.startDate && data?.endDate) {
                url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&type=${data?.type}`
            } else if (data?.date) {
                url += `&startDate=${data?.date}&type=${data?.type}`
            } else {
                url += `&month=${data?.month}&year=${data?.year}&type=${data?.type}`
            }
        } else {
            if (data?.isSixMonths) {
                url += `&orgId=${data.orgId}&isSixMonths=${data.isSixMonths}`
            } else if (data?.orgId) {
                if (data?.startDate && data?.endDate) {
                    url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&orgId=${data?.orgId}`
                } else if (data?.date) {
                    url += `&startDate=${data?.date}&orgId=${data?.orgId}`
                } else {
                    url += `&month=${data?.month}&year=${data?.year}&orgId=${data?.orgId}`
                }
            } else if (data?.clinicId) {
                if (data?.startDate && data?.endDate) {
                    url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&clinicId=${data.clinicId}`
                } else if (data?.date) {
                    url += `&startDate=${data?.date}&clinicId=${data.clinicId}`
                } else {
                    url += `&month=${data?.month}&year=${data?.year}&clinicId=${data.clinicId}`
                }
            } else {
                url += `&month=${data.month}&year=${data.year}`
            }
        }
        if (data.isDownload) {
            // downloadAllReport(url+`&isDownload=${data.isDownload}`)
            url += `&isDownload=${data.isDownload}`

            try {
                const response = await axiosGet(url, {}, {}, {}, "blob")

                // Log the entire response to check if it is coming properly
                console.log("Response received:", response)

                if (response.status === 200) {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })

                    // Create a FileReader to read the blob data for logging purposes
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        console.log("File content as text:", reader.result)
                    }
                    reader.readAsText(blob)

                    // Proceed with file download
                    const link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "CareperformanceReport.xlsx"
                    document.body.appendChild(link) // Append the link to the body
                    link.click()
                    document.body.removeChild(link) // Remove the link after clicking
                    console.log("File downloaded successfully")
                    onSuccess()
                } else {
                    onFailure()
                    console.error(
                        "Failed to download file: ",
                        response.statusText
                    )
                }
            } catch (err) {
                onFailure()
                console.error("Error downloading the report", err)
            }
        } else if (data?.sendToemail) {
            url += `&sendToemail=${data.sendToemail}`
            console.log("urlllllllllllllll", url)
            axiosGet(url).then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess("Email sent successfully")
                } else {
                    onFailure("Email sent failed")
                }
            })
        } else {
            axiosGet(url)
                .then(response => {
                    if (
                        response.data.responseData !== null &&
                        response.data.responseData.length > 0
                    ) {
                        onSuccess(response.data.responseData)
                        dispatch(
                            logTransaction(
                                "Fetch Care Performance Report",
                                response
                            )
                        )
                    } else {
                        onFailure(response.data.responseData)
                        dispatch(
                            logTransaction(
                                "Fetch Care Performance Report Failed",
                                response
                            )
                        )
                    }
                })
                .catch(err => {
                    dispatch(
                        logTransaction(
                            "Fetch Care Performance Report Failed",
                            err
                        )
                    )
                })
        }
    }
}

export function getPerformanceReport(data, success, failure) {
    return function (dispatch, getState) {
        // const userId = getState().login.userProfile?.userId
        let program = getState().user?.program
        const url =
            getPerformanceReportBeakDown +
            `?month=${data?.month.id}&year=${data?.year.id}&clinicId=${data?.clinicId}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetch performance report success",
                            response
                        )
                    )
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure(err)
                dispatch(
                    logTransaction("Fetch performance report Failure", err)
                )
            })
    }
}

export function getPatientLevelPerformance(data, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        const url =
            getPatientLevelPerformanceReport +
            `?month=${data?.month}&year=${data?.year}&patientUserId=${data?.patientId}&programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (response.data.responseData) {
                    success(response.data.responseData)
                    dispatch(updatedSelectedPatient(response.data.responseData))
                    dispatch(
                        logTransaction(
                            "Fetch patient level performance success",
                            response
                        )
                    )
                } else {
                    failure()
                    dispatch(updatedSelectedPatient({}))
                    dispatch(
                        logTransaction(
                            "Fetch patient level performance Failure",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure(err)
                dispatch(
                    logTransaction(
                        "Fetch patient level performance Failure",
                        err
                    )
                )
            })
    }
}

//bhn time spent report

export function fetchBHNSpent(data, onSuccess, onFailure) {
    return async function (dispatch, getState) {
        console.log("dataakakakaka", data)
        let program = getState().user?.program
        let url = bhnReportURL + `?programId=${program.id}`
        if (data?.type === "All") {
            if (data?.isSixMonths) {
                url += `&type=${data?.type}&isSixMonths=${data.isSixMonths}`
            } else if (data?.startDate && data?.endDate) {
                url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&type=${data?.type}`
            } else if (data?.date) {
                url += `&startDate=${data?.date}&type=${data?.type}`
            } else {
                url += `&month=${data?.month}&year=${data?.year}&type=${data?.type}`
            }
        } else {
            console.log("clinicIdiididi", data.clinicId)
            if (data?.isSixMonths) {
                url += `&orgId=${data.orgId}&isSixMonths=${data.isSixMonths}`
            } else if (data?.orgId && !data?.clinicId) {
                console.log("clinicIdiididi", data.orgId)

                if (data?.startDate && data?.endDate) {
                    url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&orgId=${data?.orgId}`
                } else if (data?.date) {
                    url += `&startDate=${data?.date}&orgId=${data?.orgId}`
                } else {
                    url += `&month=${data?.month}&year=${data?.year}&orgId=${data?.orgId}`
                }
            } else if (data?.clinicId) {
                console.log("clinicIdiididi", data.clinicId)
                if (data?.startDate && data?.endDate) {
                    url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&clinicId=${data.clinicId}`
                } else if (data?.date) {
                    url += `&startDate=${data?.date}&clinicId=${data?.clinicId}`
                } else {
                    url += `&month=${data?.month}&year=${data?.year}&clinicId=${data?.clinicId}`
                }
            } else {
                url += `&month=${data.month}&year=${data.year}`
            }
        }
        if (data.isDownload) {
            // downloadAllReport(url+`&isDownload=${data.isDownload}`)
            url += `&isDownload=${data.isDownload}`

            try {
                const response = await axiosGet(url, {}, {}, {}, "blob")

                // Log the entire response to check if it is coming properly
                console.log("Response received:", response)

                if (response.status === 200) {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })

                    // Create a FileReader to read the blob data for logging purposes
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        console.log("File content as text:", reader.result)
                    }
                    reader.readAsText(blob)

                    // Proceed with file download
                    const link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "BhnTimeSpentReport.xlsx"
                    document.body.appendChild(link) // Append the link to the body
                    link.click()
                    document.body.removeChild(link) // Remove the link after clicking
                    console.log("File downloaded successfully")
                    onSuccess()
                } else {
                    onFailure()
                    console.error(
                        "Failed to download file: ",
                        response.statusText
                    )
                }
            } catch (err) {
                onFailure()
                console.error("Error downloading the report", err)
            }
        } else if (data?.sendToemail) {
            url += `&sendToemail=${data.sendToemail}`
            console.log("urlllllllllllllll", url)
            axiosGet(url).then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess("Email sent successfully")
                } else {
                    onFailure("Email sent failed")
                }
            })
        } else {
            schedulerInstance({
                method: "GET",
                url: url,
            })
                .then(response => {
                    if (
                        response.data.responseData !== null &&
                        response.data.responseData.length > 0
                    ) {
                        onSuccess(response.data.responseData)
                        dispatch(
                            logTransaction("Fetch Patient Summary", response)
                        )
                    } else {
                        onFailure(response.data.responseData)
                        dispatch(
                            logTransaction(
                                "Fetch Patient Summary Failed",
                                response
                            )
                        )
                    }
                })
                .catch(err => {
                    dispatch(
                        logTransaction("Fetch Patient Summary Failed", err)
                    )
                })
        }
    }
}
export function fetchBHNTimeSpent(data, onSuccess, onFailure) {
    return async function (dispatch, getState) {
        console.log("dataakakakaka", data)
        let program = getState().user?.program
        let url = bhnTimeReportURL + `?programId=${program.id}`
        if (data?.type === "All") {
            if (data?.isSixMonths) {
                url += `&type=${data?.type}&isSixMonths=${data.isSixMonths}`
            } else if (data?.startDate && data?.endDate) {
                url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&type=${data?.type}`
            } else if (data?.date) {
                url += `&startDate=${data?.date}&type=${data?.type}`
            } else {
                url += `&month=${data?.month}&year=${data?.year}&type=${data?.type}`
            }
        } else {
            console.log("clinicIdiididi", data.clinicId)
            if (data?.isSixMonths) {
                url += `&orgId=${data.orgId}&isSixMonths=${data.isSixMonths}`
            } else if (data?.orgId && !data?.clinicId) {
                console.log("clinicIdiididi", data.orgId)

                if (data?.startDate && data?.endDate) {
                    url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&orgId=${data?.orgId}`
                } else if (data?.date) {
                    url += `&startDate=${data?.date}&orgId=${data?.orgId}`
                } else {
                    url += `&month=${data?.month}&year=${data?.year}&orgId=${data?.orgId}`
                }
            } else if (data?.clinicId) {
                console.log("clinicIdiididi", data.clinicId)
                if (data?.startDate && data?.endDate) {
                    url += `&startDate=${data?.startDate}&endDate=${data?.endDate}&clinicId=${data.clinicId}`
                } else if (data?.date) {
                    url += `&startDate=${data?.date}&clinicId=${data?.clinicId}`
                } else {
                    url += `&month=${data?.month}&year=${data?.year}&clinicId=${data?.clinicId}`
                }
            } else {
                url += `&month=${data.month}&year=${data.year}`
            }
        }
        if (data.isDownload) {
            // downloadAllReport(url+`&isDownload=${data.isDownload}`)
            url += `&isDownload=${data.isDownload}`

            try {
                const response = await axiosGet(url, {}, {}, {}, "blob")

                // Log the entire response to check if it is coming properly
                console.log("Response received:", response)

                if (response.status === 200) {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })

                    // Create a FileReader to read the blob data for logging purposes
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        console.log("File content as text:", reader.result)
                    }
                    reader.readAsText(blob)

                    // Proceed with file download
                    const link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "BhnTimeSpentReport.xlsx"
                    document.body.appendChild(link) // Append the link to the body
                    link.click()
                    document.body.removeChild(link) // Remove the link after clicking
                    console.log("File downloaded successfully")
                    onSuccess()
                } else {
                    onFailure()
                    console.error(
                        "Failed to download file: ",
                        response.statusText
                    )
                }
            } catch (err) {
                onFailure()
                console.error("Error downloading the report", err)
            }
        } else if (data?.sendToemail) {
            url += `&sendToemail=${data.sendToemail}`
            console.log("urlllllllllllllll", url)
            axiosGet(url).then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess("Email sent successfully")
                } else {
                    onFailure("Email sent failed")
                }
            })
        } else {
            axiosGet(url)
                .then(response => {
                    if (
                        response.data.responseData !== null &&
                        response.data.responseData.length > 0
                    ) {
                        onSuccess(response.data.responseData)
                        dispatch(
                            logTransaction("Fetch Patient Summary", response)
                        )
                    } else {
                        onFailure(response.data.responseData)
                        dispatch(
                            logTransaction(
                                "Fetch Patient Summary Failed",
                                response
                            )
                        )
                    }
                })
                .catch(err => {
                    dispatch(
                        logTransaction("Fetch Patient Summary Failed", err)
                    )
                })
        }
    }
}
//mood assessments

export function fetchMstReport(data, onSuccess, onFailure) {
    return async function (dispatch, getState) {
        let program = getState().user?.program
        let url = mstReportURL + `?programId=${program.id}`
        if (data?.type === "All") {
            url += `?month=${data?.month}&year=${data?.year}&type=${data?.type}`
        } else {
            if (data?.orgId) {
                url += `?month=${data.month}&year=${data.year}&orgId=${data.orgId}`
            } else if (data?.clinicId) {
                url += `?month=${data.month}&year=${data.year}&clinicId=${data.clinicId}`
            } else {
                url += `?month=${data.month}&year=${data.year}`
            }
        }
        if (data.isDownload) {
            // downloadAllReport(url+`&isDownload=${data.isDownload}`)
            url += `&isDownload=${data.isDownload}`

            try {
                const response = await axiosGet(url, {}, {}, {}, "blob")

                // Log the entire response to check if it is coming properly
                console.log("Response received:", response)

                if (response.status === 200) {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })

                    // Create a FileReader to read the blob data for logging purposes
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        console.log("File content as text:", reader.result)
                    }
                    reader.readAsText(blob)

                    // Proceed with file download
                    const link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "Moodassessment.xlsx"
                    document.body.appendChild(link) // Append the link to the body
                    link.click()
                    document.body.removeChild(link) // Remove the link after clicking
                    console.log("File downloaded successfully")
                    onSuccess()
                } else {
                    onFailure()
                    console.error(
                        "Failed to download file: ",
                        response.statusText
                    )
                }
            } catch (err) {
                onFailure()
                console.error("Error downloading the report", err)
            }
        } else if (data?.sendToemail) {
            url += `&sendToemail=${data.sendToemail}`
            console.log("urlllllllllllllll", url)
            axiosGet(url).then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess("Email sent successfully")
                } else {
                    onFailure("Email sent failed")
                }
            })
        } else {
            axiosGet(url)
                .then(response => {
                    if (
                        response.data.responseData !== null &&
                        response.data.responseData.length > 0
                    ) {
                        onSuccess(response.data.responseData)

                        dispatch(logTransaction("Fetch Mst Report", response))
                    } else {
                        onFailure(response.data.responseData)
                        dispatch(
                            logTransaction("Fetch Mst Report Failed", response)
                        )
                    }
                })
                .catch(err => {
                    dispatch(logTransaction("Fetch Mst Report Failed", err))
                })
        }
    }
}

// CarePlanReport...

export function fetchCarePlanReport(data, onSuccess, onFailure) {
    return async function (dispatch, getState) {
        let program = getState().user?.program
        let url = carePlanReportURL + `?programId=${program.id}`
        if (data?.type === "All") {
            url += `?month=${data?.month}&year=${data?.year}&type=${data?.type}`
        } else {
            if (data?.orgId) {
                url += `?month=${data.month}&year=${data.year}&orgId=${data.orgId}`
            } else if (data?.clinicId) {
                url += `?month=${data.month}&year=${data.year}&clinicId=${data.clinicId}`
            } else {
                url += `?month=${data.month}&year=${data.year}`
            }
        }
        if (data.isDownload) {
            // downloadAllReport(url+`&isDownload=${data.isDownload}`)
            url += `&isDownload=${data.isDownload}`

            try {
                const response = await axiosGetJournal(url, {}, {}, {}, "blob")

                // Log the entire response to check if it is coming properly
                console.log("Response received:", response)

                if (response.status === 200) {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })

                    // Create a FileReader to read the blob data for logging purposes
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        console.log("File content as text:", reader.result)
                    }
                    reader.readAsText(blob)

                    // Proceed with file download
                    const link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "Careplan.xlsx"
                    document.body.appendChild(link) // Append the link to the body
                    link.click()
                    document.body.removeChild(link) // Remove the link after clicking
                    console.log("File downloaded successfully")
                    onSuccess()
                } else {
                    onFailure()
                    console.error(
                        "Failed to download file: ",
                        response.statusText
                    )
                }
            } catch (err) {
                onFailure()
                console.error("Error downloading the report", err)
            }
        } else if (data?.sendToemail) {
            url += `&sendToemail=${data.sendToemail}`
            console.log("urlllllllllllllll", url)
            axiosGetJournal(url).then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    onSuccess("Email sent successfully")
                } else {
                    onFailure("Email sent failed")
                }
            })
        } else {
            axiosGetJournal(url)
                .then(response => {
                    if (
                        response.data.responseData !== null &&
                        response.data.responseData.length > 0
                    ) {
                        onSuccess(response.data.responseData)
                        dispatch(
                            logTransaction("Fetch carePlan Report", response)
                        )
                    } else {
                        onFailure(response.data.responseData)
                        dispatch(
                            logTransaction(
                                "Fetch carePlan Report Failed",
                                response
                            )
                        )
                    }
                })
                .catch(err => {
                    dispatch(
                        logTransaction("Fetch carePlan Report Failed", err)
                    )
                })
        }
    }
}

export function deleteDocument(documentId, isActive, success, failure) {
    return function (dispatch) {
        let url = `${getDocumentsURL}?id=${documentId}&isActive=${isActive}`
        console.log(documentId, isActive, "response12345")

        axiosPut(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    // dispatch(deleteDocumentSuccess(response.data.responseData))
                    success()
                    dispatch(logTransaction("delete document", response))
                } else {
                    failure()
                    dispatch(logTransaction("delete document failed", url))
                }
            })
            .catch(error => {
                failure()
                dispatch(logTransaction("delete document failed", error))
            })
    }
}

export function downloadAllReport() {
    return async function (dispatch, getState) {
        let program = getState().user?.program
        let url = `${downloadAllReportURL}?type=All&startDate=2024-07-01&endDate=2024-07-31&programId=${program.id}`

        try {
            const response = await axiosGet(url, {}, {}, {}, "blob")

            // Log the entire response to check if it is coming properly
            console.log("Response received:", response)

            if (response.status === 200) {
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })

                // Create a FileReader to read the blob data for logging purposes
                const reader = new FileReader()
                reader.onloadend = () => {
                    console.log("File content as text:", reader.result)
                }
                reader.readAsText(blob)

                // Proceed with file download
                const link = document.createElement("a")
                link.href = window.URL.createObjectURL(blob)
                link.download = "ConsentDaily.xlsx"
                document.body.appendChild(link) // Append the link to the body
                link.click()
                document.body.removeChild(link) // Remove the link after clicking
                console.log("File downloaded successfully")
                // onSuccess()
            } else {
                // onFailure()
                console.error("Failed to download file: ", response.statusText)
            }
        } catch (err) {
            // onFailure()
            console.error("Error downloading the report", err)
        }
    }
}

export function fetchPatientDemographic(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = patientDemographic
        axiosGet(url, {}, { ...data, programId: program.id })
            .then(response => {
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {})
    }
}

export function fetchAssessmentNameScores(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = patientAssessmentNamesScores
        axiosGet(url, {}, { ...data, programId: program.id })
            .then(response => {
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {})
    }
}

export function fetchSummaryNotes(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = patientSummaryNotes
        axiosGet(url, {}, { ...data, programId: program.id })
            .then(response => {
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {})
    }
}

export function fetchPatientCarePercent(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = patientCarePercent
        axiosGet(url, {}, { ...data, programId: program.id })
            .then(response => {
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {})
    }
}

export function fetchPatientAssessmentResponses(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = patientAssessmentResponses
        axiosGet(url, {}, { ...data, programId: program.id })
            .then(response => {
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {})
    }
}

export function fetchPatientAppointments(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = patientAppointment
        axiosGet(url, {}, { ...data, programId: program.id })
            .then(response => {
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {})
    }
}

export function fetchPatientCareGoals(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = patientCareGoals
        axiosGet(url, {}, { ...data, programId: program.id })
            .then(response => {
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {})
    }
}

export function fetchPatientFooter(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = patientFooter
        axiosGet(url, {}, { ...data, programId: program.id })
            .then(response => {
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {})
    }
}
// getOrganizationTemplate

export function fetchOrganizationTemplate(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = getOrganizationTemplate
        console.log("sledifhskudefbvkusfbv")
        axiosGet(url, {}, { ...data, programId: program?.id })
            .then(response => {
                console.log(response, "sledifhskudefbvkusfbv")
                if (response.data.responseData !== null) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {})
    }
}

export function saveOrganizationTemplate(data, onSuccess, onFailure) {
    return function (dispatch, getState) {
        let url = saveOrgTemplate
        let program = getState().user?.program
        console.log("sledifhskudefbvkusfbv")
        axiosPost(url, { ...data, programId: program?.id })
            .then(response => {
                console.log(response, "sledifhskudefbvkusfbv")
                if (response.data.statusCD === 200) {
                    onSuccess(response.data.responseData)
                } else {
                    onFailure(response.data.responseData)
                }
            })
            .catch(err => {
                onFailure()
            })
    }
}

export function getBillablePatientStatusCount(data, success, failure) {
    return function (dispatch, getState) {
        let url = billablePatientStatusCountURL
        let program = getState().user?.program
        url += `?programId=${program.id}&month=${data.month}&year=${data.year}&clinicId=${data.clinicId}`
        axiosGet(url)
            .then(response => {
                console.log(response, "sledifhskudefbvkusfbv")
                if (response.data.statusCD === 200) {
                    success(response.data.responseData?.[0])
                } else {
                    failure(response.data.responseData)
                }
            })
            .catch(err => {
                failure()
            })
    }
}

export function getCMS1500FormDetails(
    data,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url =
            getCMS1500FormDetailsUrl +
            `?programId=${program.id}&patientId=${data.patientId}&appointmentId=${data.appointmentId}`
        axiosGet(url)
            .then(res => {
                if (res.data.statusCD === 200) success(res.data.responseData)
            })
            .catch(e => {
                failure(e)
            })
    }
}
